'use strict';

module.exports = require('./server.node');



//////////////////
// WEBPACK FOOTER
// ./~/_react-dom@16.2.0@react-dom/server.js
// module id = 45
// module chunks = 0